import { createSlice } from "@reduxjs/toolkit";
import { routerChangeAction, Routes } from "const";
import cloneDeep from 'lodash/cloneDeep'
import moment from "moment-timezone";

const initialState = {
  submitting: false,
  page: 1,
  direction: 0,
  sendingOTP: false,
  assetKcus: {
    pending: false,
    data: {},
  },
  fromFundId: null,
  riskUserProfileLevel: null,
  exchangeRateFlag: null,
  availableSwitchFundsTemp: {
    // '[fundId]': {
    //   pending: false,
    //   funds: [],
    // },
  },
}

const handlePageChange = (state, targetPage) => {
  state.direction = targetPage - state.page
  state.page = targetPage
}

const slice = createSlice({
  initialState,
  name: "switch",
  extraReducers: (builder) => {
    builder.addCase(routerChangeAction, (state, { payload }) => {
      if (payload.location.pathname === Routes.UltraHigh.BuySellSwitching.Switch) {
        return cloneDeep(initialState)
      }
    })
  },
  reducers: {
    initialSwitchFund: state => cloneDeep(initialState),
    inquirySuitabilitySuccess: (state, { payload }) => {
      state.riskUserProfileLevel = payload.riskUserProfileLevel
      state.exchangeRateFlag = payload.exchangeRateFlag
    },
    inquirySuitabilityFailure: (state, { payload }) => {
      state.riskUserProfileLevel = null
    },
    gotoInitialPage: state => handlePageChange(state, 1),
    gotoConfirmPage: state => handlePageChange(state, 2),
    gotoOtpPage: state => handlePageChange(state, 3),
    gotoTransactionSuccessPage: state => handlePageChange(state, 4),
    goBack: state => {
      if (state.page !== 1) {
        state.page--
        state.direction = -1
      }
    },
    getAssetKcus: (state) => {
      state.assetKcus.pending = true
    },
    getAssetKcusSuccess: (state, action) => {
      state.assetKcus.pending = false
      state.assetKcus.data = action.payload
      state.assetKcus.done = true
    },
    getAssetKcusFailure: (state) => {
      state.assetKcus.pending = false
      state.assetKcus.done = true
    },
    sendOTP: (state, action) => {
      state.sendingOTP = true
      state.otp = null
    },
    sendOTPSuccess: (state, action) => {
      state.sendingOTP = false
      state.otp = action.payload
    },
    sendOTPFailure: state => {
      state.sendingOTP = false
    },
    submit: state => {
      state.submitting = true
    },
    submitSuccess: (state, action) => {
      state.submitting = false
      state.resultTransaction = action.payload
      handlePageChange(state, 4)
    },
    submitFailure: state => {
      state.submitting = false
    },
    fetchAvailableSwitchFunds: (state, { payload }) => {
      state.fromFundId = payload.fundId
      if (!state.availableSwitchFundsTemp[payload.fundId]) {
        state.availableSwitchFundsTemp[payload.fundId] = {
          pending: true,
          funds: [],
        }
      }
    },
    fetchAvailableSwitchFundsSuccess: (state, { payload }) => {
      state.availableSwitchFundsTemp[payload.fundId] = {
        pending: false,
        funds: payload.funds,
      }
    },
    fetchAvailableSwitchFundsFailure: (state, { payload }) => {
      state.availableSwitchFundsTemp[payload.fundId] = {
        pending: false,
      }
    },
    updateFormState: (state, action) => {
      state.form = { ...state.form, ...action.payload }
    },
    setCutOffInfo: (state, { payload }) => {
      const info = { ...payload }
      const $cutOffTime = moment(info.cutOffTime, 'HH:mm:ss'),
        $effectiveDate = moment(info.effectiveDate, 'YYYYMMDD'),
        $current = moment(info.transactionDate),
        currentDateStr = $current.format('YYYYMMDD');

      const sendTransToDay = currentDateStr === info.effectiveDate
      info.messageId = sendTransToDay
        ? "pwm.bss.confirm.sell-switch.type-1"
        : "pwm.bss.confirm.sell-switch.type-2"

      // for display purpose
      info.cutOffTimeDisplay = $cutOffTime.format('HH:mm')
      info.effectiveDateDisplay = $effectiveDate.format('DD/MM/YY')
      state.cutOffInfo = info
    },
  },
})

export const {
  initialSwitchFund,
  getRedeemAccount,
  getRedeemAccountSuccess,
  getRedeemAccountFailure,
  gotoInitialPage,
  gotoConfirmPage,
  gotoOtpPage,
  gotoTransactionSuccessPage,
  goBack,
  getAssetKcus,
  getAssetKcusSuccess,
  getAssetKcusFailure,
  sendOTP,
  sendOTPSuccess,
  sendOTPFailure,
  submit,
  submitSuccess,
  submitFailure,
  fetchAvailableSwitchFunds,
  fetchAvailableSwitchFundsSuccess,
  fetchAvailableSwitchFundsFailure,
  inquirySuitabilitySuccess,
  inquirySuitabilityFailure,
  updateFormState,
  setCutOffInfo,
} = slice.actions;

export default slice;


